<template>
  <!-- 添加产品 -->
  <div class="container ">
    <div class="vue">
      <div class="header padHorizontal10 flex flexJc-sb flexAi-c">
        <div class="text">{{ title }}</div>
        <div class="padR10">
          <el-button size="mini" @click="goBack" icon="el-icon-back"
            >返回</el-button
          >
        </div>
      </div>
      <div class="content flex">
        <div class="right FZ0875">
          <div class="form flex">
            <span class="text">产品名称</span>
            <el-input
              v-model="formShop.cate_name"
              size="small"
              placeholder=""
            ></el-input>
          </div>
          <div class="form flex">
            <span class="text">产品分类</span>
            <el-select
              class=""
              size="small"
              v-model="formShop.parentid"
              placeholder="请选择"
            >
              <!-- <el-option key="0" label="无上级分类" value="0"> </el-option> -->
              <el-option
                v-for="item in productList"
                :key="item.cateId"
                :label="item.cateName"
                :value="item.cateId"
              >
              </el-option>
            </el-select>
          </div>
          <div class="form flex">
            <span class="text">服务类型</span>
            <el-select
              class=""
              size="small"
              v-model="formShop.cateType"
              placeholder="请选择"
            >
              <!-- <el-option key="0" label="无上级分类" value="0"> </el-option> -->
              <el-option
                v-for="item in cateTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="form flex">
            <span class="text">产品图片</span>
            <div class="image">
              <el-upload
                action="#"
                list-type="picture-card"
                :file-list="fileList"
                :on-remove="handleRemove"
                :limit="1"
                :http-request="uploadSectionFile"
                :on-exceed="handleExceed"
              >
                <!-- <i class="el-icon-plus"></i> -->
                <div class="addimage flex ">
                  <el-image
                    :src="require('@/assets/ProductManage/tjtp.png')"
                  ></el-image>
                  <span class="text">添加图片</span>
                </div>
              </el-upload>
              <!-- <div class="imagelist"></div> -->
            </div>
          </div>
          <div class="form flex">
            <span class="text">服务视频</span>
            <!-- action必选参数, 上传的地址 -->
            <div class="video textL">
              <el-upload
                class="avatar-uploader el-upload--text "
                :action="uploadUrl"
                name="upload_file"
                :show-file-list="false"
              >
                <video
                  v-if="formShop.cate_mv !== '' && formShop.cate_mv !== null"
                  :src="formShop.cate_mv"
                  class="avatar"
                  controls="controls"
                >
                  您的浏览器不支持视频播放
                </video>
                <i
                  v-else-if="
                    formShop.cate_mv === '' && formShop.cate_mv === null
                  "
                  class="el-icon-plus avatar-uploader-icon"
                ></i>
                <el-progress
                  v-if="videoFlag == true"
                  type="circle"
                  :percentage="videoUploadPercent"
                  style="margin-top:30px;"
                ></el-progress>
              </el-upload>
              <div>请保证视频格式正确，且不超过10M</div>
            </div>
          </div>
          <div class="form flex">
            <span class="text">价格</span>
            <el-input v-model="formShop.cate_price" size="small"></el-input>
          </div>
          <div class="form flex">
            <span class="text">新用户体验价</span>
            <el-input v-model="formShop.cate_newprice" size="small"></el-input>
          </div>
          <div class="form flex">
            <span class="text">计费方式</span>
            <el-select
              class=""
              size="small"
              v-model="formShop.pay_unit"
              placeholder="请选择"
            >
              <el-option key="0" label="时间" value="0"> </el-option>
              <el-option key="1" label="次" value="1"> </el-option>
            </el-select>
          </div>
          <div class="form flex">
            <span class="text">排序</span>
            <el-input-number
              size="small"
              v-model="formShop.cate_order"
              controls-position="right"
              :min="0"
            ></el-input-number>
          </div>
          <div class="form flex">
            <span class="text">产品简介</span>
            <vue-ueditor-wrap
              class="ueditor"
              v-model="formShop.cate_desc"
              :config="myConfig"
            ></vue-ueditor-wrap>
          </div>
        </div>
      </div>
      <div class="footer flex flexAi-c flexJc-c">
        <el-button class="sure" size="small" type="primary" @click="confirmBut"
          >确认</el-button
        >
        <el-button @click="goBack" class="sure" size="small" plain
          >取消</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
import {
  apiAddCategory,
  apiGetCategoryList,
  apiEditCategory
} from '@/api/ProductManage'
import { apiUploadByBase64 } from '@/api/uploading'
let _self
export default {
  name: '',
  props: [''],

  data() {
    return {
      title: '',
      uploadActionUrl: '',
      routeData: '',
      formShop: {
        cate_name: '',
        cate_pic: '',
        cate_mv: '',
        cate_desc: '', // 简介
        cate_price: '',
        cate_newprice: '',
        pay_unit: '0',
        parentid: '0',
        cateType: '',
        cate_order: '' // 排序（0最前面）（默认0）
      },
      myConfig: {
        UEDITOR_HOME_URL: '/UEditor/',
        serverUrl: '',
        // 工具栏是否可以浮动
        autoFloatEnabled: false
      },
      uploadUrl: '', // 上传地址
      videoFlag: false, //
      productList: [], //
      cateTypeList: [{id: 0,name: '养老服务'},{id: 1,name: '健康服务'}],
      fileList: [],
      imageUrl: '',
      dialogVisible: false,
      imageUpload: '',
      disabled: false,
      msg: ''
    }
  },
  components: { VueUeditorWrap },
  computed: {},

  beforeMount() {},

  mounted() {
    _self = this
    this.uploadUrl = this.baseURL + '/upload/upload.do'
    this.myConfig.serverUrl = this.baseURL + '/upload/upload.do'
    if (this.$route.query.info !== undefined) {
      this.routeData = JSON.parse(this.$Base64.decode(this.$route.query.info))
      console.log(this.routeData)
      this.title = '编辑产品'
      this.edit()
    } else {
      this.title = '添加产品'
    }
    this.GetCategoryList()
  },

  methods: {
    // 返回
    goBack() {
      this.$router.go(-1)
    },
    // 编辑产品时
    edit() {
      this.formShop.cate_name = this.routeData.cateName
      this.formShop.cate_pic = this.routeData.catePic
      this.formShop.cate_mv = this.routeData.cateMv
      this.formShop.cate_desc = this.routeData.cateDesc
      this.formShop.parentid = this.routeData.parentid
      this.formShop.cate_price = this.routeData.catePrice
      this.formShop.cate_newprice = this.routeData.cateNewprice
      this.formShop.pay_unit = this.routeData.payUnit.toString()
      this.formShop.cateType = this.routeData.cateType
      console.log(this.formShop)
      this.fileList = [
        { name: 'img', url: this.baseImage + this.routeData.catePic }
      ]
    },
    addimageBut() {},
    /**
     * 文件上传-自定义上传行为
     * */
    uploadSectionFile(params, file1) {
      if (_self.fileList.length > 0) {
        this.$message.error('最高可上传一个图片')
        return
      }
      console.log(params)
      console.log(file1)
      const file = params.file
      const fileType = file.type
      const isImage = fileType.indexOf('image') !== -1
      console.log(file)
      const isLt2M = file.size / 1024 / 1024 < 2
      // 这里常规检验，看项目需求而定
      // if (!isImage) {
      //   this.$message.error('只能上传图片格式png、jpg、gif!')
      //   return
      // }
      // if (!isLt2M) {
      //   this.$message.error('只能上传图片大小小于2M')
      //   return
      // }
      // 将图片转成base64
      const reader = new FileReader()
      reader.readAsDataURL(file) // 开始转
      reader.onload = function(e) {
        // const _self = this
        // this.result // 这个就是base64编码了
        this.imageUrl = this.result.split('base64,')[1]
        apiUploadByBase64({
          base64: this.imageUrl,
          path: 'BackstageShop'
        }).then(res => {
          if (res.status === 0) {
            _self.$message({
              message: '图片上传成功',
              type: 'success'
            })
            _self.imageUpload = res.data
            _self.fileList[0] = res.data
          }
        })
        console.log(_self.imageUpload)
        console.log(_self.fileList)
      }
    },
    // 删除文件之前的钩子
    handleRemove(file, fileList) {
      _self.fileList = []
    },
    // 文件超出个数限制时的钩
    handleExceed(file, fileList) {
      console.log(fileList)
      console.log(this.fileList)
      this.$message.error('最高可上传一个图片')
    },
    editorClick(e) {
      // console.log(e)
    },
    // 按钮
    // 确定上传按钮
    confirmBut() {
      // 添加
      if (this.routeData === '') {
        apiAddCategory({
          cateName: this.formShop.cate_name,
          catePic: this.formShop.cate_pic,
          parentid: this.formShop.parentid,
          cateDesc: this.formShop.cate_desc,
          cateService: this.formShop.cate_service,
          catePrice: this.formShop.cate_price,
          cateNewprice: this.formShop.cate_newprice,
          cateOrder: this.formShop.cate_order,
          payUnit: this.formShop.pay_unit,
          serviceType: this.formShop.pay_unit,
          cateMv: this.formShop.cate_mv,
          cateType: this.formShop.cateType
          // show_price: this.formShop.show_price
        }).then(res => {
          if (res.status === 0) {
            this.$Ms(res.msg)
          }
        })
      } else {
        // 编辑
        apiEditCategory({
          cateId: this.routeData.cateId,
          cateName: this.formShop.cate_name,
          catePic: this.formShop.cate_pic,
          parentid: this.formShop.parentid,
          cateDesc: this.formShop.cate_desc,
          cateService: this.formShop.cate_service,
          catePrice: this.formShop.cate_price,
          cateNewprice: this.formShop.cate_newprice,
          cateOrder: this.formShop.cate_order,
          payUnit: this.formShop.pay_unit,
          serviceType: this.formShop.pay_unit,
          cateMv: this.formShop.cate_mv,
          cateType: this.formShop.cateType
          // show_price: this.formShop.show_price
        }).then(res => {
          if (res.status === 0) {
            this.$Ms(res.msg)
            this.$router.go(-1)
          }
        })
      }
    },

    // 接口
    // 产品列表
    GetCategoryList() {
      apiGetCategoryList({
        page: 1,
        pageSize: 100
      }).then(res => {
        if (res.status === 0) {
          this.productList = res.data.list.filter(res => {
            return res.parentid === 0
          })
          this.productList.unshift({cateId: 0, cateName: '无上级分类'});
          console.log(this.productList)
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.FZ0875 {
  font-size: 0.875em;
}
.vue {
  height: calc(100vh - 120px);
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    line-height: 40px;
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
    }
  }
  .content {
    height: calc(100% - 90px);
    padding: 20px;
    width: auto;
    overflow: auto;
    position: relative;
    background: #fff;

    .left {
      width: 30%;
    }
    .right {
      width: 70%;
      .form {
        width: 100%;
        line-height: 3;
        // align-items: center;
        justify-content: flex-start;
        padding-bottom: 10px;
        text-align: right;
        .text {
          width: 12%;
          padding-right: 10px;
        }
        .sure {
          padding: 8px 28px;
        }
        /deep/ .video,
        /deep/ .ueditor {
          width: 88%;
        }
        .video {
          /deep/ .el-upload {
            width: 148px;
            height: 148px;
            border: 1px dashed #c0ccda;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        .image {
          .addimage {
            height: 100%;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .el-image {
              width: 30px;
              height: 30px;
            }
            .text {
              padding: 0;
              padding-top: 10px;
              width: 100%;
              line-height: normal;
            }
          }
          //   .left_name {
          //     width: 80px;
          //     height: 80px;
          //     border: 1px solid #e3e3e3;
          //     padding: 6px;
          //     flex-direction: column;
          //     align-items: center;
          //     justify-content: center;
          //     color: #858585;
          //   }
        }
        .el-input,
        .editor,
        .el-select,
        .el-input-number {
          width: 88%;
          /deep/ input {
            text-align: left;
          }
        }
        /deep/ .el-input-number__decrease {
          height: 19px;
        }
        .el-input-number--small {
          line-height: inherit;
        }
      }
    }
  }
  .footer {
    height: 50px;
  }
}
</style>
